import React from 'react'

const Plus = (props: { className: any, onClick?: any, circleHidden?: boolean, style?: any }) => {
  const { className, onClick, circleHidden, style } = props;



  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}>
      {!circleHidden && <circle cx="9" cy="9" r="8" />}
      <path d="M9 6.33301V11.6663" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.33203 9L11.6654 9" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};
export default Plus;

